import {
  ScrollTrigger
} from "./chunk.RYXMHMS2.js";
import {
  gsapWithCSS
} from "./chunk.LXB4MYP4.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-campaign-page-hero/jb-campaign-page-hero.scss?inline
var jb_campaign_page_hero_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.location-wrapper, ul {
  font-family: var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-regular-weight, 400);
}

p, h1 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h1 {
  font-size: var(--theme-typo-h1-mobile-fontsize, 2.125rem);
  line-height: var(--theme-typo-h1-mobile-lineheight, 2.75rem);
}
@media (min-width: 1281px) {
  h1 {
    font-size: var(--theme-typo-h1-desktop-fontsize, 3.125rem);
    line-height: var(--theme-typo-h1-desktop-lineheight, 4.375rem);
  }
}

p {
  font-size: var(--theme-typo-p-big-mobile-fontsize, 1.188rem);
  line-height: var(--theme-typo-p-big-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  p {
    font-size: var(--theme-typo-p-big-desktop-fontsize, 1.375rem);
    line-height: var(--theme-typo-p-big-desktop-lineheight, 2.125rem);
  }
}

.location-wrapper, ul {
  font-size: var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);
  line-height: var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  --_grid-gap: 16px;
  --_grid-template-columns: repeat(12, 1fr);
  --_outer-padding: calc(6.68% - var(--_grid-gap));
  display: grid;
  gap: var(--grid-row-gap, 0) var(--grid-column-gap, var(--_grid-gap));
  grid-template-columns: [full-start] var(--_outer-padding) [main-start] var(--thme-grid-template-columns, var(--_grid-template-columns)) [main-end] var(--_outer-padding) [full-end];
  grid-template-rows: 1fr;
  padding-inline-end: var(--compensate-scrollbar);
}
@media (min-width: 600px) {
  :host {
    --_outer-padding: calc(8.35% - var(--_grid-gap));
  }
}
@media (min-width: 960px) {
  :host {
    --_grid-gap: 40px;
    --_outer-padding: calc(6.955% - var(--_grid-gap) / 2);
  }
}
@media (min-width: 1281px) {
  :host {
    padding-block-start: var(--spacing-s);
  }
}
@media (min-width: 1437px) {
  :host {
    --_outer-padding: calc((100% - 1437px - 40px) / 2);
  }
}

:host {
  color: var(--host-color, #141e55);
}

.scroll-wrapper {
  display: grid;
  grid-column: full;
  grid-template-columns: subgrid;
}

::slotted(jb-button-primary),
::slotted(jb-button-secondary),
::slotted(jb-button-tertiary) {
  inline-size: 100%;
  margin-block-end: var(--spacing-m);
}
@media (min-width: 600px) {
  ::slotted(jb-button-primary),
  ::slotted(jb-button-secondary),
  ::slotted(jb-button-tertiary) {
    inline-size: auto;
    padding-inline-end: var(--spacing-s);
  }
}

h1 {
  padding-block: var(--spacing-m) var(--spacing-sm);
  padding-inline-end: var(--spacing-xs);
}
@media (min-width: 1281px) {
  h1 {
    padding-block-start: 0;
  }
}

p {
  padding-block-end: var(--spacing-2xs);
  padding-inline-end: var(--spacing-xs);
}

ul {
  list-style: none;
}
ul li {
  column-gap: var(--spacing-2xs);
  display: flex;
}
@media (min-width: 600px) {
  ul.anchor-links {
    inline-size: fit-content;
  }
}
ul.anchor-links li {
  border-block-end: 1px solid rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
  padding-block: var(--spacing-3xs);
}
ul.anchor-links li a {
  text-decoration: none;
}
ul.anchor-links li jb-in-page-icon {
  transition: translate 0.3s ease-in-out;
}
ul.anchor-links li:hover jb-in-page-icon {
  translate: 0 3px;
}

jb-teaser-meta {
  display: block;
  padding-block: var(--spacing-base) var(--spacing-3xs);
}

.breadcrumbs-outer {
  display: grid;
  grid-column: main;
  padding-block: var(--spacing-lm);
  place-content: center;
}
@media (min-width: 1281px) {
  .breadcrumbs-outer {
    display: none;
  }
}

.breadcrumbs-inner {
  display: none;
}
@media (min-width: 1281px) {
  .breadcrumbs-inner {
    display: block;
    padding-block-end: var(--spacing-s);
  }
}

.content-inset {
  background-color: white;
  grid-column: full-start/main-start;
  margin-inline-end: calc(-1 * var(--_grid-gap));
  translate: 0 calc(var(--spacing-3xl) * -1);
}
@media (min-width: 960px) {
  .content-inset {
    translate: 0 calc(var(--spacing-4xl) * -1);
  }
}
@media (min-width: 1281px) {
  .content-inset {
    display: none;
  }
}

.content-wrapper {
  grid-column: main;
  translate: 0 calc(var(--spacing-3xl) * -1);
}
.content-wrapper > * {
  background-color: #fff;
  padding-inline-end: 16px;
}
.content-wrapper > *:not(:first-child) {
  padding-block-start: var(--spacing-xs);
}
@media (min-width: 960px) {
  .content-wrapper {
    grid-column: 2/12;
    translate: 0 calc(var(--spacing-4xl) * -1);
  }
}
@media (min-width: 1281px) {
  .content-wrapper {
    display: flex;
    flex-direction: column;
    grid-column: main-start/9;
    justify-content: center;
    margin-inline-end: 0;
    order: 1;
    translate: 0;
  }
}

.image-wrapper {
  grid-column: full;
  margin-inline: 0;
  position: relative;
}
.image-wrapper jb-picture {
  clip-path: inset(0 0 var(--clip-path, 0));
}
@media (min-width: 1281px) {
  .image-wrapper {
    block-size: calc(100svh - 120px);
    grid-column: 9/full-end;
    order: 2;
    padding-inline-end: 60px;
  }
  .image-wrapper > * {
    block-size: 100%;
  }
}

.location-wrapper {
  column-gap: var(--spacing-2xs);
  display: flex;
  padding-block-start: var(--spacing-base);
}

.preslot {
  margin-block-end: var(--spacing-m);
}
.preslot > :last-child {
  margin-block-end: 0;
  padding-block-end: 0;
}

.parallax-wrapper {
  display: grid;
  grid-column: main;
  grid-template-columns: subgrid;
  order: 3;
  z-index: 1;
}
.parallax-wrapper .parallax-frame {
  background-color: white;
  grid-column: 1/13;
  padding: var(--spacing-l);
}
@media (min-width: 960px) {
  .parallax-wrapper {
    grid-column: 3/13;
    margin-inline: 0;
  }
}
@media (min-width: 1281px) {
  .parallax-wrapper {
    display: block;
    grid-column: 4/12;
  }
}`;

// src/components/jb-campaign-page-hero/jb-campaign-page-hero.ts
var JbCampaignPageHero = class extends h {
  async firstUpdated() {
    await this.updateComplete;
    this._setupAnimations();
    setTimeout(() => {
      this._scrollWrapper.style.height = "100%";
    }, 50);
  }
  _allFalsy(obj) {
    return !Object.values(obj).some((value) => !!value);
  }
  _renderBreadcrumbs() {
    return ke`
      <jb-breadcrumbs>
        ${this.breadcrumbs.backlink && ke`<jb-breadcrumbs-back-link
          .link=${this.breadcrumbs.backlink.link}
          .text=${this.breadcrumbs.backlink.text}
          slot="backlink"
        ></jb-breadcrumbs-back-link>`}
        ${this.breadcrumbs.items?.map(
      (breadcrumb) => ke`<jb-breadcrumbs-item
              .link=${breadcrumb.link}
              .text=${breadcrumb.text}
              slot="items"
            ></jb-breadcrumbs-item>`
    )}
      </jb-breadcrumbs>
    `;
  }
  _setupAnimations() {
    gsapWithCSS.registerPlugin(ScrollTrigger);
    const mm = gsapWithCSS.matchMedia();
    mm.add("(max-width: 1280px)", () => {
      gsapWithCSS.to(this._imageWrapper, {
        y: -180,
        scrollTrigger: {
          id: "scrollTriggerMoveMobile",
          trigger: this,
          scrub: true,
          start: "top +=60px",
          // 60px navbar
          end: "bottom"
        }
      });
      return () => {
      };
    });
    mm.add("(min-width: 1281px)", () => {
      const contentWrapperDiv = this._contentWrapper.querySelector("div");
      if (contentWrapperDiv.clientHeight + 185 < window.innerHeight - 100) {
        gsapWithCSS.to(this._parallaxWrapper.querySelector(".parallax-frame"), { marginTop: -80 });
      }
      gsapWithCSS.to([this._contentWrapper, this._imageWrapper.querySelector("jb-picture")], {
        y: -200,
        scrollTrigger: {
          id: "scrollTriggerMoveHero",
          trigger: this._scrollWrapper,
          scrub: true,
          start: "bottom bottom",
          end: "bottom 20%"
        }
      });
      ScrollTrigger.create({
        trigger: this._imageWrapper,
        pin: true,
        pinSpacing: false,
        start: "top-=60 top",
        // half the header size from top
        end: "bottom bottom-=60",
        // half the header size from bottom
        endTrigger: this._scrollWrapper
      });
      gsapWithCSS.to(this._imageWrapper.querySelector("jb-picture"), {
        scrollTrigger: {
          id: "scrollTriggerInset",
          trigger: this._scrollWrapper,
          scrub: true,
          start: "bottom bottom",
          end: "bottom 50%"
        },
        "--clip-path": "128px",
        yoyo: true
      });
      return () => {
      };
    });
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "campaign-page-hero"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <div class="scroll-wrapper">
        <div class="breadcrumbs-outer">${this.breadcrumbs && this._renderBreadcrumbs()}</div>
        <div class="image-wrapper">
          <jb-picture
            .imgData=${this.image.picture.imgData}
            fit="cover"
          ></jb-picture>
        </div>
        <div class="content-inset"></div>
        <div class="content-wrapper">
          <div>
            <div class="preslot">
              <div class="breadcrumbs-inner">${this.breadcrumbs && this._renderBreadcrumbs()}</div>
              <h1>${this.headline}</h1>
              <p>${this.subline}</p>
              ${this.featureList && ke` <jb-feature-list .features=${this.featureList}></jb-feature-list>`}
              ${!this._allFalsy(this.teaserMeta) ? ke` <jb-teaser-meta
                    .date=${this.teaserMeta.date}
                    .category=${this.teaserMeta.category}
                    .time=${this.teaserMeta.time}
                    .timeZone=${this.teaserMeta.timeZone ? this.teaserMeta.timeZone : D}
                    .link=${this.teaserMeta.link}
                  ></jb-teaser-meta>` : D}
              ${this.location && ke`<div class="location-wrapper">
                <jb-pin-icon></jb-pin-icon>
                <div>${this.location.map((item) => ke` <div>${item}</div> `)}</div>
              </div>`}
            </div>
            <slot @jb-link:clicked=${this._tracking}></slot>
            ${this.anchorLinks && ke`<ul class="anchor-links">
              ${this.anchorLinks.filter((item) => item.link?.href).map(
      (item) => ke`<li><jb-in-page-icon></jb-in-page-icon><a href="${item.link.href}">${item.text}</a></li>`
    )}
            </ul>`}
          </div>
        </div>
      </div>
      <div class="parallax-wrapper">
        <div class="parallax-frame">
          <slot name="parallaxElement"></slot>
        </div>
      </div>
    `;
  }
};
JbCampaignPageHero.styles = r(jb_campaign_page_hero_default);
__decorateClass([
  n({ type: Array })
], JbCampaignPageHero.prototype, "anchorLinks", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignPageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n({ type: Array })
], JbCampaignPageHero.prototype, "featureList", 2);
__decorateClass([
  n()
], JbCampaignPageHero.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignPageHero.prototype, "image", 2);
__decorateClass([
  n({ type: Array })
], JbCampaignPageHero.prototype, "location", 2);
__decorateClass([
  n()
], JbCampaignPageHero.prototype, "subline", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignPageHero.prototype, "teaserMeta", 2);
__decorateClass([
  e(".content-inset")
], JbCampaignPageHero.prototype, "_contentInset", 2);
__decorateClass([
  e(".content-wrapper")
], JbCampaignPageHero.prototype, "_contentWrapper", 2);
__decorateClass([
  e(".image-wrapper")
], JbCampaignPageHero.prototype, "_imageWrapper", 2);
__decorateClass([
  e(".parallax-wrapper")
], JbCampaignPageHero.prototype, "_parallaxWrapper", 2);
__decorateClass([
  e(".scroll-wrapper")
], JbCampaignPageHero.prototype, "_scrollWrapper", 2);
JbCampaignPageHero = __decorateClass([
  customElement("jb-campaign-page-hero")
], JbCampaignPageHero);

export {
  JbCampaignPageHero
};
